
export {} from '@clayui/label';
import __x__ from '@clayui/label';export default __x__;